export default "__VITE_ASSET__DYAmZxcX__"